/**
 * Highly experimental, the name might change.
 */
export const unstable_allowServer = <T>(x: T) => x;
